import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ApplicationState } from '../../../../../store';
import AfterTravelDocumentsDashboard, { IDispatchProps, IProps } from './index';
import { closeModal, openFollowUpDocumentModal, openUploadFollowUpModal } from '../../../../../store/ui/actions';
import { approveDoc } from '../../../../../store/student/followUpDocuments/actions';
import { SectionStatusType } from 'api-paths-cas';
import { saveFollowUpDocumentsShareCode } from '../../../../../store/student/actions';
import { hasAnyMatchingFollowUpDocs } from '../../../../../utilities/documents';

const mapStateToProps = (state: ApplicationState): IProps => {
  const isAfterArrivalAreaHidden =
    state.student.config?.afterArrivalDocAreaStatus === SectionStatusType.INACTIVE &&
    !state.student.summary.isAfterArrivalDocsStarted;
  const { followUpDocuments } = state.student;

  const hasRequiredAfterArrivalDocs = hasAnyMatchingFollowUpDocs(followUpDocuments, 'afterArrival', 'required');
  const hasStaffOnlyAfterArrivalDocs = hasAnyMatchingFollowUpDocs(followUpDocuments, 'afterArrival', 'staffOnly');
  const hasAgentOnlyAfterArrivalDocs = hasAnyMatchingFollowUpDocs(followUpDocuments, 'afterArrival', 'agentOnly');

  return {
    hasRequiredAfterArrivalDocs,
    hasStaffOnlyAfterArrivalDocs,
    hasAgentOnlyAfterArrivalDocs,
    openModal: state.ui.openModal,
    documents: followUpDocuments,
    userRole: state.auth.role,
    serviceProviderType: state.auth.serviceProviderType,
    dob: state.student.personalInfo.dob,
    isAfterArrivalAreaHidden,
    afterArrivalDocsRequired: state.student.summary.afterArrivalDocsRequired,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  openFollowUpModal: (
    sponsorType: string | null,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    modalTitle?: string,
    data?: Record<string, unknown>,
  ): void => {
    dispatch(openFollowUpDocumentModal(sponsorType, sponsorKey, docType, docKey, modalTitle, data));
  },
  onApproveDoc: (
    sponsorType: string,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    docStatus?: string,
    docPrevStatus?: string,
  ): void => {
    dispatch(approveDoc(sponsorType, sponsorKey, docType, docKey, docStatus, docPrevStatus));
  },
  openUploadModal: (
    sponsorType: string,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    modalTitle: string,
    fileNames: string[],
    metadata?: unknown,
  ): void => {
    dispatch(openUploadFollowUpModal(sponsorType, sponsorKey, docType, docKey, modalTitle, fileNames, metadata));
  },
  closeModal: (): void => {
    dispatch(closeModal());
  },
  saveShareCode: (docKey: string, data: Record<string, unknown>): void => {
    dispatch(saveFollowUpDocumentsShareCode(docKey, data));
    dispatch(closeModal());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AfterTravelDocumentsDashboard);
